import {useEffect} from 'react'
import {ILayout, useLayout, useMobileSidebar} from '../../core'
import {SidebarMenu} from './sidebar-menu/SidebarMenu'
import {SidebarLogo} from './SidebarLogo'
import {setAuthToken} from '../../../../app/modules/auth/core/dataAxios'

const Sidebar = () => {
  const {config} = useLayout()
  const {isMobile, isOpen, close} = useMobileSidebar()
  const token: string | null = localStorage.getItem('token')

  useEffect(() => {
    updateDOM(config)
    setAuthToken(token)
  }, [config])

  if (!config.app?.sidebar?.display) {
    return null
  }

  const hiddenOnMobile = isMobile && !isOpen

  return (
    <>
      <div
        id='kt_app_sidebar'
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: isMobile ? 'min(18rem, 86vw)' : '16rem',
          height: '100vh',
          zIndex: isMobile ? 120 : 40,
          backgroundColor: '#f8fafc',
          display: 'flex',
          flexDirection: 'column',
          padding: '1.5rem 1rem',
          overflowY: 'auto',
          overflowX: 'hidden',
          boxShadow: isOpen && isMobile ? '8px 0 24px rgba(0, 52, 127, 0.12)' : 'none',
          border: 'none',
          transform: hiddenOnMobile ? 'translateX(-110%)' : 'translateX(0)',
          transition: 'transform 0.22s ease',
          pointerEvents: hiddenOnMobile ? 'none' : 'auto',
        }}
      >
        <SidebarLogo />
        <SidebarMenu />
      </div>
      {isMobile && isOpen && (
        <div
          className='app-sidebar-mobile-backdrop'
          onClick={close}
          aria-hidden='true'
          style={{
            display: 'block',
            position: 'fixed',
            inset: 0,
            zIndex: 110,
            background: 'rgba(15, 23, 42, 0.45)',
          }}
        />
      )}
    </>
  )
}

const updateDOM = (_config: ILayout) => {
  const sidebarFlags = [
    'data-kt-app-sidebar-minimize',
    'data-kt-app-sidebar-hoverable',
    'data-kt-app-sidebar-minimize-mobile',
    'data-kt-app-sidebar-hoverable-mobile',
    'data-kt-app-sidebar-collapse',
    'data-kt-app-sidebar-collapse-mobile',
    'data-kt-app-sidebar-push-header',
    'data-kt-app-sidebar-push-toolbar',
    'data-kt-app-sidebar-push-footer',
  ]
  sidebarFlags.forEach((attr) => document.body.removeAttribute(attr))
  document.documentElement.style.setProperty('--kt-app-sidebar-width', '16rem')
  document.documentElement.style.setProperty('--kt-app-sidebar-gap-start', '0px')
  document.documentElement.style.setProperty('--kt-app-sidebar-gap-end', '0px')
  document.body.removeAttribute('app-sidebar-stacked')
  document.body.setAttribute('data-kt-app-sidebar-enabled', 'true')
  document.body.setAttribute('data-kt-app-sidebar-fixed', 'true')

  setTimeout(() => {
    const sidebarElement = document.getElementById('kt_app_sidebar')
    if (sidebarElement) {
      const sidebarAttributes = sidebarElement
        .getAttributeNames()
        .filter((t) => t.indexOf('data-') > -1)
      sidebarAttributes.forEach((attr) => sidebarElement.removeAttribute(attr))
    }
  }, 0)
}

export {Sidebar}
